<div class="card mb-2">
  <div class="card-header text-danger">
    <app-icon name="pay" class="mr-2" width="1.5rem" height="1.5rem" />
    <strong>{{ 'PAYMENT_METHODS.title' | alpitranslate }}</strong>
  </div>
  @if (paymentMethods$ | async; as paymentMethods) {
    <div class="card-body">
      <div class="text">
        {{ 'PAYMENT_METHODS.availableInCountry' | alpitranslate }}
      </div>
      <div class="row align-items-center justify-content-center">
        @for (paymentMethod of paymentMethods | keyvalue; track paymentMethod) {
          @switch (paymentMethod.key) {
            @case ('visa') {
              <div class="col-3 mt-3">
                <img
                  class="img-fluid"
                  [attr.data-test]="'paymentMehtodIconSidebar-' + paymentMethod.key"
                  src="{{ 'images/payments/on-card/methods/visa.svg' | platformasset: true }}" />
              </div>
            }
            @case ('mastercard') {
              <div class="col-3 mt-3">
                <img
                  class="img-fluid"
                  [attr.data-test]="'paymentMehtodIconSidebar-' + paymentMethod.key"
                  src="{{ 'images/payments/on-card/methods/mastercard.svg' | platformasset: true }}" />
              </div>
            }
            @case ('diners') {
              <div class="col-3 mt-3">
                <img
                  class="img-fluid"
                  [attr.data-test]="'paymentMehtodIconSidebar-' + paymentMethod.key"
                  src="{{ 'images/payments/on-card/methods/diners.svg' | platformasset: true }}" />
              </div>
            }
            @case ('directdebit') {
              <div class="col-3 mt-3">
                <img
                  class="img-fluid"
                  [attr.data-test]="'paymentMehtodIconSidebar-' + paymentMethod.key"
                  src="{{ 'images/payments/on-card/methods/directdebit.svg' | platformasset: true }}" />
              </div>
            }
            @case ('paypal') {
              <div class="col-3 mt-3">
                <img
                  class="img-fluid"
                  [attr.data-test]="'paymentMehtodIconSidebar-' + paymentMethod.key"
                  src="{{ 'images/payments/on-card/methods/paypal.svg' | platformasset: true }}" />
              </div>
            }
            @case ('giropay') {
              <div class="col-3 mt-3">
                <img
                  class="img-fluid"
                  [attr.data-test]="'paymentMehtodIconSidebar-' + paymentMethod.key"
                  src="{{ 'images/payments/on-card/methods/giropay.svg' | platformasset: true }}" />
              </div>
            }
            @case ('ideal') {
              <div class="col-3 mt-3">
                <img
                  class="img-fluid"
                  [attr.data-test]="'paymentMehtodIconSidebar-' + paymentMethod.key"
                  src="{{ 'images/payments/on-card/methods/ideal.svg' | platformasset: true }}" />
              </div>
            }
            @case ('maestro') {
              <div class="col-3 mt-3">
                <img
                  class="img-fluid"
                  [attr.data-test]="'paymentMehtodIconSidebar-' + paymentMethod.key"
                  src="{{ 'images/payments/on-card/methods/maestro.svg' | platformasset: true }}" />
              </div>
            }
            @case ('sofort') {
              <div class="col-3 mt-3">
                <img
                  class="img-fluid"
                  [attr.data-test]="'paymentMehtodIconSidebar-' + paymentMethod.key"
                  src="{{ 'images/payments/on-card/methods/sofort.svg' | platformasset: true }}" />
              </div>
            }
            @case ('postfinance') {
              <div class="col-3 mt-3">
                <img
                  class="img-fluid"
                  [attr.data-test]="'paymentMehtodIconSidebar-' + paymentMethod.key"
                  src="{{ 'images/payments/on-card/methods/postfinance.svg' | platformasset: true }}" />
              </div>
            }
            @case ('cartesbancaires') {
              <div class="col-3 mt-3">
                <img
                  class="img-fluid"
                  [attr.data-test]="'paymentMehtodIconSidebar-' + paymentMethod.key"
                  src="{{ 'images/payments/on-card/methods/cartesbancaires.svg' | platformasset: true }}" />
              </div>
            }
            @case ('googlepay') {
              <div class="col-3 mt-3">
                <img
                  class="img-fluid"
                  [attr.data-test]="'paymentMehtodIconSidebar-' + paymentMethod.key"
                  src="{{ 'images/payments/on-card/methods/googlepay.svg' | platformasset: true }}" />
              </div>
            }
            @case ('applepay') {
              <div class="col-3 mt-3">
                <img
                  class="img-fluid"
                  [attr.data-test]="'paymentMehtodIconSidebar-' + paymentMethod.key"
                  src="{{ 'images/payments/on-card/methods/applepay.svg' | platformasset: true }}" />
              </div>
            }
          }
        }
      </div>
    </div>
  }
</div>
